<template>
	<div class="zhi" v-if="dialogVisiblesss==true">
		<div class="zhiclose"></div>
		<div class="zhis">
			<div class="zhiss">
				<div class="weixin-login-title">
					   <i></i>
					   <span>微信扫码支付</span>
				</div>
				<div class="qrcode-wrapper">
				   <div class="qrcode-container" v-loading="loading" id="qrcode" ref="qrCodeUrl">
					
				   </div>
				</div>
				<div style="width: 100%;text-align: center;margin-top: 10px;">
					支付金额：
					<span style="color: red;">¥{{money}}</span>
				</div>
				<i class="el-icon-circle-close" @click="dialogVisiblesss=false"></i>
			</div>
		</div>
	</div>
</template>

<script>
	import QRCode from 'qrcodejs2'
	import { pc_pay } from "@/api/user"
	import { user_huanjing_detail,user_ghuanjing_detail,user_yunxing_detail,baoming_detail,user_xufei_detail } from "@/api/huanjing"
	export default {
		data(){
			return{
				loading:false,
				id:'',//订单id
			    code_url:'',
				dialogVisiblesss:false,
				money:0,
				timer:null,
				
				type:100,//1共享环境加入申请订单 2运行资源申请订单
			}
		},
		methods:{
			show(id,money,type){
				this.$nextTick(()=>{
					this.dialogVisiblesss = true
					this.id = id
					this.money = money
					this.type = type?type:100
					this.pc_pay();
				})
			},
			pc_pay(){
				this.loading = true
				pc_pay({
					id:this.id,
					type:this.type
				}).then(res=>{
					this.loading = false
					console.log("支付参数",res.data);
					this.code_url = res.data
					new QRCode('qrcode', {
						text: res.data,
						width: 240,
						height: 240,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H
					})
					//轮训查看订单状态
					this.timer = setInterval(()=>{
						if(this.type==100){
							user_huanjing_detail({
								id:this.id
							}).then(res=>{
								console.log("订单详情",res.data);
								if(res.data.status==1){
									clearInterval(this.timer)
									this.$message.success("支付成功");
									this.dialogVisiblesss = false
									this.$emit("successpay");
								}
							})
						}
						if(this.type==1){
							user_ghuanjing_detail({
								id:this.id
							}).then(res=>{
								console.log("订单详情",res.data);
								if(res.data.status==1){
									clearInterval(this.timer)
									this.$message.success("支付成功");
									this.dialogVisiblesss = false
									this.$emit("successpay");
								}
							})
						}
						if(this.type==2){
							user_yunxing_detail({
								id:this.id
							}).then(res=>{
								console.log("订单详情",res.data);
								if(res.data.status==1){
									clearInterval(this.timer)
									this.$message.success("支付成功");
									this.dialogVisiblesss = false
									this.$emit("successpay");
								}
							})
						}
						if(this.type==3){
							baoming_detail({
								id:this.id
							}).then(res=>{
								console.log("订单详情",res.data);
								if(res.data.status==1){
									clearInterval(this.timer)
									this.$message.success("支付成功");
									this.dialogVisiblesss = false
									this.$emit("successpay");
								}
							})
						}
						if(this.type==4){
							user_xufei_detail({
								id:this.id
							}).then(res=>{
								console.log("订单详情",res.data);
								if(res.data.status==1){
									clearInterval(this.timer)
									this.$message.success("支付成功");
									this.dialogVisiblesss = false
									this.$emit("successpay");
								}
							})
						}
					},2000)
				}).catch(()=>{
					this.loading = false
				})
			},
		},
		watch:{
			dialogVisiblesss(e){
				if(e==false){
					this.id = ''
					this.money = ''
					this.code_url = ''
					this.type = 100
					clearInterval(this.timer)
				}
			},
		},
	}
</script>

<style lang="scss" scoped>

	.zhi{
		width: 100vw;
		height: 100vw;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 9999;
		.el-icon-circle-close{
			font-size: 20px;
			position: absolute;
			right: 20px;
			top: 30px;
			cursor: pointer;
		}
		.zhis{
			width: 100%;
			height: 100%;
			position: absolute;
			z-index: 2;
			.zhiss{
				width: 400px;
				height: 400px;
				background: #fff;
				border-radius: 10px;
				position: absolute;
				top: 10vh;
				left: 50%;
				margin-left: -200px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.weixin-login-title{
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 20px;
					color: rgba(0,0,0,.8);
					width: 100%;
					i{
						display: inline-block;
						width: 26px;
						height: 26px;
						background-image: url(../../../assets/svg/logreg_sprite.svg);
						background-position: -29px -28px;
						margin-right: 10px;
					}
				}
				.qrcode-wrapper{
					width: 204px;
					height: 204px;
					background: #fff;
					// border: 1px solid #eee;
					border-radius: 6px;
					margin: 24px auto;
					display: flex;
					align-items: center;
					justify-content: center;
					.qrcode-container{
						position: relative;
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						img{
							width: 250px;
							height: 250px;
						}
					}
				}
			}
		}
		.zhiclose{
			width: 100%;
			height: 100%;
			position: absolute;
			z-index: 1;
			background: #000;
			opacity: 0.6;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/zhifu.vue